import Vue from "vue";
export default Vue.extend({
    name: "AppLoader",
    props: {
        show: { type: Boolean, default: false },
        // Modes
        overlay: { type: Boolean, default: true },
        fullscreen: { type: Boolean, default: false },
        // Visuals
        size: { type: Number, default: 44 },
        color: { type: String, default: "#2563eb" },
        trackColor: { type: String, default: "rgba(37, 99, 235, 0.18)" },
        backdropColor: { type: String, default: "rgba(255, 255, 255, 0.75)" },
        blurBackdrop: { type: Boolean, default: false },
        zIndex: { type: Number, default: 99 },
        padding: { type: String, default: "16px" },
        gap: { type: String, default: "10px" },
        // Text / a11y
        label: { type: String, default: "" },
        subLabel: { type: String, default: "" },
        srText: { type: String, default: "Loading" },
        ariaLabel: { type: String, default: "" },
    },
    computed: {
        ariaLabelComputed() {
            // include subLabel in aria if present
            const parts = [this.ariaLabel, this.label, this.subLabel, this.srText].filter(Boolean);
            return parts[0] || "Loading";
        },
    },
});
